const menu = [
    {
        name: 'Painel principal',
        link: route('app.home'),
        component: "Home",
        icon: 'bi-grid'
    },

    {
        name: 'Usuários',
        link: route('app.usuarios.index'),
        component: ["Usuarios", "Usuarios/Edit"],
        icon: 'bi-people',
        can: ['ADM']
    },

    {
        name: 'Alunos',
        link: route('app.alunos.index'),
        component: "Alunos",
        icon: 'bi-person-lines-fill',
        can: ['ADM']
    },

    {
        name: 'Avaliadores',
        link: route('app.avaliadores.index'),
        component: "Avaliadores",
        icon: 'bi-people',
        can: ['ADM']
    },

    {
        name: 'Avaliação',
        link: route('app.projetos.avaliar'),
        component: ["AvaliarProjetos", "AvaliaProjeto"],
        icon: 'bi-award-fill',
        can: ['AVA']
    },

    {
        name: 'Projetos',
        link: route('app.projetos.index'),
        component: ["Projetos", "CorrigeProjeto"],
        icon: 'bi-ui-checks',
        can: ['ADM', 'ORI']
    },

    {
        name: 'Relatórios',
        icon: 'bi-card-list',
        component: ['RelCamisetas', 'RelProjetos'],
        can: ['ADM'],
        menus: [
            {
                name: 'Camisetas',
                link: route('app.relatorios.camisetas'),
                component: "RelCamisetas",
                can: ['ADM'],
            },
            {
                name: 'Projetos',
                link: route('app.relatorios.projetos'),
                component: "RelProjetos",
                can: ['ADM'],
            },
            {
                name: 'Avaliadores',
                link: route('app.relatorios.avaliadores'),
                component: "RelAvaliadores",
                can: ['ADM'],
            }
        ]
    },

    {
        name: 'Configurações',
        link: route('app.core.configs'),
        component: "Config",
        icon: 'bi-gear',
        can: ['ADM']
    },
];

export default menu;
